import * as React from "react";
import { forwardRef, memo } from "react";
const SvgArrowLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.4141 4.03534L5.41406 11.0353H22V13.0353H5.41406L12.4141 20.0353L11 21.4494L2.29297 12.7424C1.90252 12.3518 1.90247 11.7188 2.29297 11.3283L11 2.62128L12.4141 4.03534Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowLeft);
const Memo = memo(ForwardRef);
export default Memo;
